import { Component, ViewEncapsulation } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { FuseConfigService } from '@fuse/services/config.service';
import {AuthService} from 'app/auth/auth.service';
import { fuseAnimations } from '@fuse/animations';
import *  as $ from 'jquery';
import { lang_login } from 'app/idiomas/i18n/login/login.lang';
///IDIOMAS
import { lang_perfiles } from 'app/idiomas/i18n/perfiles/perfiles.lang';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import * as configuracion from 'app/configuracion/login';
import { DATOS_API } from 'app/auth/auth.datos';
import { LoginResetPasswordService } from './login-reset-password.service';
import { ActivatedRoute, Router } from '@angular/router';
import {MatSnackBar} from '@angular/material/snack-bar';
@Component({
  selector: 'app-reset-password',
  templateUrl: './login-reset-password.component.html',
  styleUrls: ['./login-reset-password.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations   : fuseAnimations
})
export class LoginResetPasswordComponent  {
  selectedLanguage: any;
  languages: any;
  urlAssets = DATOS_API.urlAssets;
  configLogin:any;
  token:any;
  charChinos = '\u2E80-\u2FD5\u3400-\u4DBF\u4E00-\u9FCC';
  charTurcos = '\u011F\u011E\u0131\u0130\u00F6\u00D6\u00FC\u00DC\u015F\u015E\u00E7\u00C7';
  charIdiomas = this.charChinos + this.charTurcos;
  regexEmail = new RegExp("^[" + this.charIdiomas + "a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[" + this.charIdiomas + "a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[" + this.charIdiomas + "a-zA-Z0-9](?:[" + this.charIdiomas + "a-zA-Z0-9-]*[" + this.charIdiomas + "a-zA-Z0-9])?\.)+[" + this.charIdiomas + "a-zA-Z0-9](?:[" + this.charIdiomas + "a-zA-Z0-9-]*[" + this.charIdiomas + "a-zA-Z0-9])?$");

  medirPassRegis:number=0;
  longitudPassRegis:boolean=false;
  regalasPassRegis:any[]=[
    {
      'regla': 'longitud',
       'estatus': false,
  },
    {
      'regla': 'letraMin',
       'estatus': false,
  },
    {
      'regla': 'letraMayu',
       'estatus': false,
  },
    {
      'regla': 'numeroPass',
       'estatus': false,
  },
    {
      'regla': 'caracterPass',
       'estatus': false,
  },
  ]
  letraMinPassRegis:boolean=false;
  letraMayuPassRegis:boolean=false;
  numePassRegis:boolean=false;
  caracterPassRegis:boolean=false;
  arregloReglasCumplidasRegis:any[]=[];
  styleElementRegis: HTMLStyleElement;
  passwordOkRegis:boolean=false;
  hide = true;
  constructor(
    private _fuseConfigService: FuseConfigService,
    private _formBuilder: FormBuilder,
    public authService: AuthService,
    private router: Router,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private _translateService: TranslateService,
    private loginpasswordreset: LoginResetPasswordService,
    private activatedRoute : ActivatedRoute,
    private acti2vatedRoute: ActivatedRoute,
    private _snackBar: MatSnackBar,
    private translateSrv: TranslateService,
  ) {
    this.activatedRoute.queryParams.subscribe(params => {
      this.token = params['tk'];
      this.loginpasswordreset.setToken(this.token);
      //console.log("token "+this.token);
      //this.searchToken(this.token);
    });

    this.configLogin = configuracion.loginCGO;
    this.languages = [
      {
          id   : 'en',
          title: 'English',
          flag : 'us',
          short: 'en'
      },
      {
          id   : 'es',
          title: 'Español',
          flag : 'es',
          short: 'es'
      },
      {
          id   : 'tr',
          title: 'Turkish',
          flag : 'tr',
          short: 'tr'
      },
      {
        id   : 'zh1',
        title: 'Traditional Chinese',
        flag : 'zh',
        short: 'zh'
      },
      {
        id   : 'zh2',
        title: 'Simplified Chinese',
        flag : 'zh',
        short: 'zh'
      },
      {
        id   : 'pt',
        title: 'Portuguese',
        flag : 'pt',
        short: 'pt'
      }
    ];

    this._fuseConfigService.config = {
      layout: {
        navbar   : {hidden: true},
        toolbar  : {hidden: true},
        footer   : {hidden: true},
        sidepanel: {hidden: true},
      }
    };
    this.selectedLanguage="es";

    lang_perfiles.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });

   }

    ngOnInit() {
      this.styleElementRegis = document.createElement('style');
       this.searchToken(this.token);
      //
    }
  firtsPassword:any="";
  secondPassword:any="";
  setLanguage(lang): void{
    console.log("Idioma "+lang);
    this.selectedLanguage = lang;
    this._translateService.use(lang);
  }
  showForm:boolean=null;
  email:any;
  idUsuario:any;
  bloquearBtn:boolean=true;
  bloquearConfirmar:boolean=true;

  searchToken(token){
    this.loginpasswordreset.searchToken(token).subscribe( (data: any) => {
      console.log(data);
      if(data.success){
        this.showForm=true;
        this.email=data.user;
        this.idUsuario=data.id;
      }else{
        this.showForm=false;
      }
    },error=>{
      console.log("Error");
      this.showForm=false;
    });
  }

  verifyPassword1(){
    if(this.firtsPassword.length>=3){
      console.log("Adelante");
      this.bloquearConfirmar=false;
    }
  }
  verifyPassword2(){
    console.log('secondPassword',this.secondPassword);
    console.log('firtsPassword',this.firtsPassword);
    console.log('passwordOkRegis',this.passwordOkRegis);
    console.log(this.secondPassword.length);
    if(this.secondPassword.length>=3){
      if(this.firtsPassword==this.secondPassword){
        console.log("Adelante btn",this.bloquearBtn);
        this.bloquearBtn=false;
      }else{
        this.openErrorSnackBar(this.translateSrv.instant('LOGIN.RESET.NOPASSWORDMATCH'),"OK");
      }
    }else{
      this.openErrorSnackBar("Deben ser al menos 3 carácteres","OK");
    }
  }
  showMessage:boolean=false;
  changePassword(){
    let datos={
      user:this.email,
      password: this.firtsPassword,
    }
    console.log(datos);
    this.loginpasswordreset.actualizarUsuario(datos).subscribe((response:any) => {
      this.bloquearBtn=true;
      console.log(response);
      if(response.success){
        this.showMessage=true;
        this.opentrueSnackBar(this.translateSrv.instant('LOGIN.RESET.SUCCESSCHANGE'),"OK");
        this.authService.nullToken();
      }
    }, error => {
      console.log(error);
    })
  }
  opentrueSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
       duration: 1500,
       verticalPosition: 'bottom',
       panelClass: ['background-success']
    });
  }

  openErrorSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
       duration: 1500,
       verticalPosition: 'bottom',
       panelClass: ['background-red']
    });
  }

  goPassword(){
    this.router.navigate(['login']);
  }

  validarPassRegis(event:any){
    if (this.firtsPassword.length==0) {
      this.secondPassword="";
    }
    const head = document.getElementsByTagName('head')[0];
    let css='';
    this.medirPassRegis=0;
    console.log(event.target.value);
    let regexPass = new RegExp("^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*([_]|[ -\/]|[:-\@]|[[-\`]|[{-\■])).{8,64}$");
    let regexMin = new RegExp("^(?=.*[a-z]).{1,64}$");
    let regexMay = new RegExp("^(?=.*[A-Z]).{1,64}$");
    let regexNum = new RegExp("^(?=.*[0-9]).{1,64}$");
    let regexCharEsp = new RegExp("[_]|[ -\/]|[:-\@]|[[-\`]|[{-\■]");
    if(event.target.value.length >= 10){
      this.longitudPassRegis=true;
      this.regalasPassRegis[0].estatus=true;
    }else{
      this.longitudPassRegis=false;
      this.regalasPassRegis[0].estatus=false;
    }

    if(regexMin.test(event.target.value)){
      this.letraMinPassRegis=true;
      this.regalasPassRegis[1].estatus=true;
    }else{
      this.letraMinPassRegis=false;
      this.regalasPassRegis[1].estatus=false;
    }

    if(regexMay.test(event.target.value)){
      this.letraMayuPassRegis=true;
      this.regalasPassRegis[2].estatus=true;
    }else{
      this.letraMayuPassRegis=false;
      this.regalasPassRegis[2].estatus=false;
    }

    if(regexNum.test(event.target.value)){
      this.numePassRegis=true;
      this.regalasPassRegis[3].estatus=true;
    }else{
      this.numePassRegis=false;
      this.regalasPassRegis[3].estatus=false;
    }

    if(regexCharEsp.test(event.target.value)){
      this.caracterPassRegis=true;
      this.regalasPassRegis[4].estatus=true;
    }else{
      this.caracterPassRegis=false;
      this.regalasPassRegis[4].estatus=false;
    }


    console.log('regalasPass',this.regalasPassRegis);
    this.arregloReglasCumplidasRegis=[];

this.regalasPassRegis.forEach(estatus => {
 if (estatus.estatus==true) {
   this.arregloReglasCumplidasRegis.push(estatus);
 }
});

console.log('arregloReglasCumplidasRegis',this.arregloReglasCumplidasRegis);
if (this.arregloReglasCumplidasRegis.length==1) {
 this.medirPassRegis=10;
 css = css+`
 .valorRegis .mat-progress-bar-fill::after {
   background-color: #cc0000 !important;
 }`;

}else if (this.arregloReglasCumplidasRegis.length==2) {
 this.medirPassRegis=30;
 css = css+`
 .valorRegis .mat-progress-bar-fill::after {
   background-color: #cc0000 !important;
 }`;

}else if (this.arregloReglasCumplidasRegis.length==3) {
 this.medirPassRegis=50;
 css = css+`
 .valorRegis .mat-progress-bar-fill::after {
   background-color: #F1EB2B !important;
 }`;

}else if (this.arregloReglasCumplidasRegis.length==4) {
 this.medirPassRegis=70;
 css = css+`
 .valorRegis .mat-progress-bar-fill::after {
   background-color: #F19C2B !important;
 }`;

}else if (this.arregloReglasCumplidasRegis.length==5) {
 this.medirPassRegis=100;
 css = css+`
 .valorRegis .mat-progress-bar-fill::after {
   background-color: #46761D !important;
 }`;

}
if (this.medirPassRegis==100) {
 this.passwordOkRegis=true;
}else{
  this.passwordOkRegis=false;

}

this.styleElementRegis.innerHTML = '';
this.styleElementRegis.type = 'text/css';
this.styleElementRegis.appendChild(document.createTextNode(css));
head.appendChild(this.styleElementRegis);

  }

  mostrarPassword(e?){
    e.preventDefault();
  }
}
